import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { supabase } from '../Utils/supabase';

function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const isHospitalUser = localStorage.getItem('hospitalAuthenticated') === 'true';

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'dark') {
      setIsDarkMode(true);
      document.documentElement.classList.add('dark-mode');
    }
  }, []);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
    if (!isDarkMode) {
      document.documentElement.classList.add('dark-mode');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark-mode');
      localStorage.setItem('theme', 'light');
    }
  };

  const handleLogout = async () => {
    try {
      localStorage.clear();
      
      // Sign out from Supabase
      await supabase.auth.signOut();
      
      // Redirect to home page
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <i className="fas fa-plus-square medical-icon"></i>
        <span>Uropine</span>
      </div>

      <div className="nav-links">
        <Link to={isHospitalUser ? "/dashboard" : "/dashboard"}
          className={`nav-link ${location.pathname === '/dashboard' ? 'active' : ''}`}
          title="Dashboard">
          <i className="fas fa-chart-line nav-icon"></i>
          <span className="nav-text">Dashboard</span>
        </Link>
        <Link to="/dashboard/hospital" 
          className={`nav-link ${location.pathname.includes('/dashboard/hospital') ? 'active' : ''}`}
          title="Hospital">
          <i className="fas fa-hospital nav-icon"></i>
          <span className="nav-text">Hospital</span>
        </Link>
        <Link to="/dashboard/reports" 
          className={`nav-link ${
            location.pathname.includes('/dashboard/reports') || 
            location.pathname === '/patientDetails' ||
            location.pathname.includes('/patient-details')
          ? 'active' : ''}`}
          title="Reports">
          <i className="fas fa-file-alt nav-icon"></i>
          <span className="nav-text">Reports</span>
        </Link>
      </div>
      
      <div className="nav-actions">
        <button className="theme-toggle" onClick={toggleTheme}>
          <i className={`fas ${isDarkMode ? 'fa-sun' : 'fa-moon'}`}></i>
        </button>
        <button className="logout-btn" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i>
          <span className="nav-text">Logout</span>
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
